module.exports = __webpack_public_path__ + "components/flag/static/square/cl-78c98502c96857cdfcfb09d155a805c5.svg";